// 不良情報画像
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import apiAxios from "../utils/apiAxios";
import { AnyAction, Dispatch } from "redux";
import { appendAlert } from "../redux/alertSlice";
import cloneDeep from "lodash/cloneDeep";
import { GetDefectReportAttachements } from "../models/GetDefectReportAttachements";

export type DefectReportAttachements = {
  defectReportAttachements: GetDefectReportAttachements[];
};

const initialState: DefectReportAttachements = {
  defectReportAttachements: [],
};

export const defectReportAttachementSlice = createSlice({
  name: "defects",
  initialState,
  reducers: {
    setDefectReportAttachements: (
      state,
      action: PayloadAction<GetDefectReportAttachements[]>
    ) => {
      state.defectReportAttachements = action.payload;
    },
    removeDefectReportAttachement: (state, action: PayloadAction<string>) => {
      // 引数は削除対象画像ファイルのkey
      const workDefectReports = cloneDeep(state.defectReportAttachements);
      workDefectReports.forEach((defectReportAttachement) => {
        defectReportAttachement.files = defectReportAttachement.files.filter(
          (d) => d.key !== action.payload
        );
      });
      state.defectReportAttachements = workDefectReports;
    },
  },
});

const { setDefectReportAttachements, removeDefectReportAttachement } =
  defectReportAttachementSlice.actions;

// 不良画像データの取得
const fetchDefectReportAttachements = (
  po_data_num: string,
  po_desc_num: string,
  mach_seq: number,
  failure_count: number,
  defect_type_seq: number
) => {
  return async (dispatch: Dispatch<AnyAction>) => {
    try {
      const url = `defect_report_attachements?po_data_num=${po_data_num}&po_desc_num=${po_desc_num}&mach_seq=${mach_seq}&failure_count=${failure_count}&defect_type_seq=${defect_type_seq}`;
      const response = await apiAxios.get<GetDefectReportAttachements[]>(url);
      dispatch(setDefectReportAttachements(response.data));
    } catch (error: any) {
      console.error(error);
      dispatch(
        appendAlert({
          severity: "error",
          message: "不良画像データの取得に失敗しました。" + error.message,
          displayTime: 5000,
        })
      );
    }
  };
};

const deleteDefectReportAttachement = (key: string) => {
  return async (dispatch: Dispatch<AnyAction>) => {
    try {
      const url = `/defect_report_attachement/${key}`;
      await apiAxios.delete(url);
      console.log("画像削除しました : " + key);
      dispatch(removeDefectReportAttachement(key));
    } catch (error: any) {
      console.error(error);
      dispatch(
        appendAlert({
          severity: "error",
          message: "画像削除に失敗しました " + key,
          displayTime: 5000,
        })
      );
    }
  };
};

export {
  setDefectReportAttachements,
  fetchDefectReportAttachements,
  deleteDefectReportAttachement,
};
export default defectReportAttachementSlice.reducer;
